var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitlensLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 230,
    r: 210,
    fill: "#2ECC71"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "white",
    stroke: "white"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 70,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 120,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 230,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 340,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 390,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 340,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 230,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 120,
    r: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 70,
    x2: 140,
    y2: 120,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 120,
    x2: 90,
    y2: 230,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 230,
    x2: 140,
    y2: 340,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 340,
    x2: 230,
    y2: 390,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 390,
    x2: 320,
    y2: 340,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 340,
    x2: 370,
    y2: 230,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370,
    y1: 230,
    x2: 320,
    y2: 120,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 120,
    x2: 230,
    y2: 70,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 120,
    x2: 320,
    y2: 340,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 230,
    x2: 370,
    y2: 230,
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 340,
    x2: 320,
    y2: 120,
    stroke: "white",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230,
    cy: 230,
    rx: 250,
    ry: 80,
    stroke: "black",
    strokeWidth: 20,
    fill: "none",
    transform: "rotate(-30, 230, 230)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 200,
    fontFamily: "Arial",
    fontSize: 120,
    fontWeight: "bold",
    fill: "#2ECC71"
  }, "BitLens"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 320,
    fontFamily: "Arial",
    fontSize: 110,
    fontWeight: "bold",
    fill: "#2ECC71"
  }, "Solutions"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 420,
    fontFamily: "Arial",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#000000"
  }, "ANALYZING TOMORROW"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitlensLogo);
export default __webpack_public_path__ + "static/media/bitlens-logo.5f409a02d40abc846b6630f8b7827046.svg";
export { ForwardRef as ReactComponent };